var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/ImportEstimation.tsx";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useMemo } from 'react';
import { useStore } from 'effector-react';
import * as estApi from '@gmini/sm-api-sdk/lib/EstimationApi';
import * as smApi from '@gmini/sm-api-sdk';
import { Button, RoundedCross, Tooltip } from '@gmini/ui-kit';
import { Dialog } from '@gmini/ui-kit/lib/Dialog';
import { filterNotExpandedTree } from "../../classifier-editor/ClassifierTree/createTree";
import { CloseButton, Title } from "../SelectDependencies/SelectDependencies.styled";
import { Footer, FooterActions, Content, SubHeader, Header, DialogBody, BackdropComponent } from "./ImportEstimation.styled";
import { importEstimationService } from "./model";
import { ImportEstimationSwitchProject, ImportEstimationTree, SubmitButton } from "./components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImportEstimation = /*#__PURE__*/React.memo(function (_ref) {
  var estimationId = _ref.estimationId,
      estimationVersion = _ref.estimationVersion,
      currentUserClassifier$ = _ref.currentUserClassifier$,
      seoEventManager = _ref.seoEventManager;
  var open = useStore(importEstimationService.opened$, {
    loc: {
      file: _effectorFileName,
      line: 51,
      column: 17
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [51, 17]"
  });
  var activeEstimation = useStore(importEstimationService.activeEstimation$, {
    loc: {
      file: _effectorFileName,
      line: 52,
      column: 29
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [52, 29]"
  });
  var importEstimationPending = useStore(estApi.Estimation.ImportEstimation.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 53,
      column: 36
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [53, 36]"
  });
  var fetchActiveEstimationPending = useStore(importEstimationService.fetchActiveEstimation.pending$, {
    loc: {
      file: _effectorFileName,
      line: 56,
      column: 41
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [56, 41]"
  });
  var flatTree = useStore(importEstimationService.treeModel.flatTree$, {
    loc: {
      file: _effectorFileName,
      line: 60,
      column: 21
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [60, 21]"
  });
  var selectedProject = useStore(importEstimationService.selectedProject$, {
    loc: {
      file: _effectorFileName,
      line: 61,
      column: 28
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [61, 28]"
  });
  var expanded = useStore(importEstimationService.expandModel.expanded$, {
    loc: {
      file: _effectorFileName,
      line: 62,
      column: 21
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [62, 21]"
  });
  var fetchFlatListPending = useStore(smApi.UserClassifier.fetchFlatListItems.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 63,
      column: 33
    },
    name: "ImportEstimation",
    sid: "ImportEstimation /src/classifier-editor/ImportEstimation/ImportEstimation.tsx [63, 33]"
  });
  var flatVisibleTree = useMemo(function () {
    return filterNotExpandedTree({
      tree: flatTree,
      expanded: expanded
    });
  }, [expanded, flatTree]);

  var onImport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currentEstimation, mostRecentClassifier;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!activeEstimation || !activeEstimation.id || !activeEstimation.version)) {
                _context.next = 2;
                break;
              }

              throw new Error('Active estimation is not defined');

            case 2:
              if (selectedProject) {
                _context.next = 4;
                break;
              }

              throw new Error('Selected project is not defined');

            case 4:
              _context.next = 6;
              return estApi.Estimation.ImportEstimation.defaultContext({
                estimationId: estimationId,
                estimationVersion: estimationVersion,
                sourceEstimationId: activeEstimation.id,
                sourceEstimationVersion: activeEstimation.version,
                sourceProjectUrn: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.urn
              });

            case 6:
              currentEstimation = _context.sent;
              seoEventManager.push({
                event: 'Gtech_Estimation_ImportTemplateStructure_Import',
                payload: {
                  estimationId: currentEstimation.id,
                  templateEstimationId: activeEstimation.id
                }
              });
              importEstimationService.close();
              _context.next = 11;
              return smApi.UserClassifier.getMostRecent.defaultContext({
                id: currentEstimation.classifierId
              });

            case 11:
              mostRecentClassifier = _context.sent;
              _context.next = 14;
              return Promise.all([estApi.Estimation.getMostRecent.defaultContext({
                id: currentEstimation.id //update estimation, because it's not always get actual classifierVersion after import

              }), smApi.UserClassifierTree.DynamicGroupItem.getList.defaultContext({
                classifierId: mostRecentClassifier.id,
                classifierVersion: mostRecentClassifier.version
              }), smApi.UserClassifier.fetchFlatListItems.defaultContext({
                classifierId: mostRecentClassifier.id,
                classifierVersion: mostRecentClassifier.version,
                skipRef: true
              })]);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onImport() {
      return _ref2.apply(this, arguments);
    };
  }();

  var isEmptyActiveEstimation = useMemo(function () {
    return flatVisibleTree.length === 0;
  }, [flatVisibleTree]);
  return /*#__PURE__*/_jsxs(Dialog, {
    onClose: importEstimationService.close,
    PaperComponent: DialogBody,
    BackdropComponent: BackdropComponent,
    open: open,
    fullWidth: true,
    maxWidth: "lg",
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: "\u0418\u043C\u043F\u043E\u0440\u0442 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0440\u0430\u0441\u0447\u0451\u0442\u0430"
      }), /*#__PURE__*/_jsx(CloseButton, {
        "data-test-id": "closeDependencyList",
        "aria-label": "close",
        onClick: function onClick() {
          return importEstimationService.close();
        },
        type: "square",
        children: /*#__PURE__*/_jsx(RoundedCross, {
          color: "rgb(83, 95, 119)"
        })
      })]
    }), /*#__PURE__*/_jsx(SubHeader, {
      children: /*#__PURE__*/_jsx(ImportEstimationSwitchProject, {
        currentUserClassifier$: currentUserClassifier$
      })
    }), /*#__PURE__*/_jsx(Content, {
      children: /*#__PURE__*/_jsx(ImportEstimationTree, {
        currentUserClassifier$: currentUserClassifier$,
        tree$: importEstimationService.tree$,
        seoEventManager: seoEventManager,
        estimationId: estimationId
      })
    }), /*#__PURE__*/_jsx(Footer, {
      children: /*#__PURE__*/_jsxs(FooterActions, {
        children: [/*#__PURE__*/_jsx(Button, {
          color: "secondary",
          size: "regular",
          onClick: function onClick() {
            return importEstimationService.close();
          },
          disabled: importEstimationPending,
          children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: !fetchFlatListPending && isEmptyActiveEstimation ? 'Отсутствует структура для импорта' : '',
          children: /*#__PURE__*/_jsx(SubmitButton, {
            disabled: !activeEstimation || isEmptyActiveEstimation,
            onClick: onImport,
            loading: importEstimationPending || fetchFlatListPending || fetchActiveEstimationPending
          })
        })]
      })
    })]
  });
});
ImportEstimation.displayName = 'ImportEstimation';